<template>
  <b-card>
    <table-pages />
  </b-card>
</template>

<script>
import TablePages from '@/layouts/components/TablePages.vue'

import {
  BCard,
} from 'bootstrap-vue'

export default {
  components: {
    TablePages,
    BCard,
  },
}
</script>
